// Fiche tarifaire officielle NBPerf — RÉFÉRENCE UNIQUE des prestations et tarifs.
// Toute modification de prix se fait ICI (et côté backend dans server.py).
export const formatEuro = (n) =>
  new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n);

export const prestationGroups = [
  {
    title: "Stages de reprogrammation",
    items: [
      { id: "stage-1", label: "Stage 1", sub: "Gain de puissance et de couple", price: 210 },
      { id: "stage-1-plus", label: "Stage 1+", sub: "Optimisation avancée", price: 220 },
      { id: "stage-2", label: "Stage 2", sub: "Performance renforcée", price: 260 },
      { id: "stage-3", label: "Stage 3", sub: "Préparation maximale", price: 300 },
      { id: "tcu", label: "Optimisation boîte TCU", sub: "Reprogrammation de la boîte de vitesse (TCU)", price: 200 },
      { id: "pack-stage-1", label: "Pack préparation moteur Stage 1+ diesel/essence", sub: "Cartographie Stage 1+ sur mesure Pro, EGR OFF, FAP OFF, volets d'admission (Flaps/TVA) OFF, Pop & Bang ou Hardcut à la demande, décata/lambda OFF pour les essences, full tube échappement, admission directe, downpipe EGR/FAP", price: 1500, pack: true, mention: "prestataire de services partie mécanique" },
      { id: "pack-stage-2", label: "Pack préparation moteur Stage 2 diesel/essence", sub: "Cartographie Stage 2, EGR OFF, FAP OFF, volets d'admission (Flaps/TVA) OFF, Pop & Bang ou Hardcut à la demande, décata/lambda OFF pour les essences, full tube échappement, admission directe, injecteurs ET turbo, downpipe", price: 2300, pack: true, mention: "prestataire de services partie mécanique" },
      { id: "pack-stage-3", label: "Pack préparation moteur Stage 3 diesel/essence", sub: "Cartographie Stage 3 sur mesure Pro, EGR OFF, FAP OFF, Flaps/TVA OFF, décata pour les essences, Pop & Bang ou Hardcut à la demande, full tube échappement, admission directe, injecteurs ET turbo, embrayage renforcé uniquement boîte mécanique, downpipe", price: 2800, pack: true, mention: "prestataire de services partie mécanique" },
    ],
    footerNote: "Étude selon votre véhicule sur demande, avec pièces à fournir, tarif forfaitaire.",
  },
  {
    title: "FlexFuel E85",
    items: [
      { id: "e85-stage1", label: "Stage 1 FlexFuel E85", sub: "selon véhicule", price: 440, confirm: true },
      { id: "e85-carto", label: "FlexFuel E85", sub: "cartographie seule", price: 350 },
    ],
  },
  {
    title: "Reprogrammations spécifiques",
    items: [
      { id: "egr-full", label: "Reprogrammation EGR OFF", price: 180 },
      { id: "dpf-full", label: "Reprogrammation DPF FAP OFF", price: 180 },
      { id: "flaps-full", label: "Reprogrammation FLAPS OFF", price: 180 },
      { id: "popbang-full", label: "Reprogrammation Pop & Bang", price: 195 },
      { id: "origine-full", label: "Remise à l'origine", price: 180 },
      { id: "hardcut-full", label: "Reprogrammation Hard Cut Limiter Diesel", price: 180 },
      { id: "egr-fap-full", label: "Reprogrammation EGR + FAP OFF", price: 205 },
      { id: "egr-fap-adblue-full", label: "Reprogrammation EGR + FAP + AdBlue OFF", price: 230 },
      { id: "lambda-popbang-full", label: "Reprog Lambda/Decata + Pop & Bang", price: 200 },
      { id: "fap-adblue-full", label: "Reprogrammation FAP + AdBlue OFF", price: 205 },
    ],
  },
  {
    title: "Diagnostic & Services",
    items: [
      { id: "diag-complet", label: "Lecture / Diagnostic complet", sub: "rapport PDF numérique inclus", price: 30 },
      { id: "effacement", label: "Effacement des défauts", price: 20 },
      { id: "regen-fap", label: "Régénération FAP (forcée)", price: 50 },
      { id: "remise-zero", label: "Remise à zéro (entretien, vidange…)", price: 20 },
      { id: "codage", label: "Codage injecteur, clé", price: null, rangeLabel: "40 – 60 €", confirm: true },
      { id: "deplacement", label: "Forfait déplacement domicile / travail", sub: "selon distance", price: null, rangeLabel: "20 – 30 €", confirm: true },
    ],
  },
];

export const optionItems = [
  { id: "egr", label: "EGR OFF", price: 35 },
  { id: "fap", label: "FAP / DPF", price: 35 },
  { id: "lambda", label: "Lambda Removed", price: 35 },
  { id: "flap", label: "FLAP (Suppression volets d'admission)", price: 35 },
  { id: "dtc", label: "DTC OFF", price: 35 },
  { id: "origine", label: "Remise à l'origine", price: 35 },
  { id: "egr-fap", label: "EGR + FAP", price: 60 },
  { id: "fap-adblue", label: "FAP + AdBlue", price: 60 },
  { id: "egr-fap-adblue", label: "EGR + FAP + AdBlue", price: 85 },
  { id: "popbang", label: "Pop&Bang", price: 50 },
  { id: "lambda-popbang", label: "Lambda + Pop&Bang", price: 80 },
  { id: "hardcut", label: "Harcut limiteur diesel", price: 35 },
];

// Packs qui incluent des options individuelles (évite le double comptage)
export const BUNDLE_PARTS = {
  "egr-fap": ["egr", "fap"],
  "fap-adblue": ["fap"],
  "egr-fap-adblue": ["egr", "fap"],
  "lambda-popbang": ["lambda", "popbang"],
};

export const allPrestations = prestationGroups.flatMap((g) => g.items);
export const findPrestation = (id) => allPrestations.find((p) => p.id === id);
export const findOption = (id) => optionItems.find((o) => o.id === id);

// Compatibilité carburant : tout id absent de cette liste = compatible tous carburants.
// Les stages, la TCU, les packs (diesel/essence), le diagnostic général, le codage,
// la remise à l'origine, le DTC OFF et le forfait déplacement restent universels.
const FUELS = {
  // FlexFuel E85 : moteurs essence (et hybrides essence)
  "e85-stage1": ["Essence", "Hybride"],
  "e85-carto": ["Essence", "Hybride"],
  // Spécifiques diesel
  "egr-full": ["Diesel"],
  "dpf-full": ["Diesel"],
  "flaps-full": ["Diesel"],
  "hardcut-full": ["Diesel"],
  "egr-fap-full": ["Diesel"],
  "egr-fap-adblue-full": ["Diesel"],
  "fap-adblue-full": ["Diesel"],
  "regen-fap": ["Diesel"],
  // Spécifiques essence
  "popbang-full": ["Essence"],
  "lambda-popbang-full": ["Essence"],
  // Options
  egr: ["Diesel"],
  fap: ["Diesel"],
  flap: ["Diesel"],
  hardcut: ["Diesel"],
  "egr-fap": ["Diesel"],
  "fap-adblue": ["Diesel"],
  "egr-fap-adblue": ["Diesel"],
  lambda: ["Essence"],
  popbang: ["Essence"],
  "lambda-popbang": ["Essence"],
};

export const matchesFuel = (item, carburant) => {
  if (!item || !carburant || carburant === "Autre") return true;
  const allowed = FUELS[item.id];
  return !allowed || allowed.includes(carburant);
};

export const priceLabel = (item) => {
  if (!item) return "Sur devis";
  if (item.price !== null && item.price !== undefined) {
    return formatEuro(item.price) + (item.confirm ? " *" : "");
  }
  return item.rangeLabel ? `${item.rangeLabel} *` : "Sur devis";
};

// Lien entre les pages services existantes et la fiche tarifaire officielle
export const servicePriceMap = {
  "reprogrammation-e85": "e85-carto",
  "reprogrammation-diesel": "stage-1",
  "stage-1": "stage-1",
  "stage-1-plus": "stage-1-plus",
  "stage-2": "stage-2",
  "stage-3": "stage-3",
  "stage-boite": "tcu",
  "egr-off": "egr",
  "dpf-off": "fap",
  "adblue-off": "devis",
  "flaps-off": "flap",
  "pop-and-bang": "popbang",
  "lambda-off": "lambda",
  "dtc-off": "dtc",
  "remise-origine": "origine",
  "hardcut-limiter": "hardcut",
  "diagnostic-electronique": "diag-complet",
  "cartographie-sur-mesure": "devis",
};

export const catalogItemForSlug = (slug) => {
  const pid = servicePriceMap[slug];
  if (!pid || pid === "devis") return null;
  return findPrestation(pid) || findOption(pid) || null;
};

export const priceLabelForSlug = (slug) => {
  const pid = servicePriceMap[slug];
  if (!pid || pid === "devis") return "Sur devis";
  return priceLabel(findPrestation(pid) || findOption(pid));
};
